import AuthLayout from 'layouts/AuthLayout';
import { SectionStyle } from './Styles';
import { Box, Typography } from '@mui/material';
import { MHidden } from 'components/@material-extend';
import { useTranslator } from 'translation/useTranslator';

const LoginGreeting = () => {
  const translator = useTranslator();
  return (
    <MHidden width="mdDown">
      <SectionStyle>
        <AuthLayout />
        <Typography variant="h3" sx={{ px: 5, mt: 10, mb: 5 }}>
          {translator.hiWelcomeBack()}
        </Typography>
        <Box p={5}>
          <img src="/static/illustrations/illustration_login.png" alt="login" />
        </Box>
      </SectionStyle>
    </MHidden>
  );
};
export default LoginGreeting;
